const navConfig = [
  {
    title: "Home",
    path: "/",
  },
  {
    title: "About Us",
    path: "/about-us",
  },
  {
    title: "Core Areas",
    path: "/our-core-areas",
  },
  {
    title: "Programs",
    path: "/our-programs",
  },
  {
    title: "Our Impact",
    path: "/our-impact",
  },
  {
    title: "Our Gallery",
    path: "/our-gallery",
  },
  {
    title: "Our Team",
    path: "/our-team",
  },
  {
    title: "Contact Us",
    path: "/contact-us",
  },
];

export default navConfig;
